<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Select/NewDSelectEditor'
export default {
  name: 'DContentSecurityEditor',
  extends: compoment
}
</script>
